<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-notice">
            <div class="notice-header">
              <h3 class="title">
                <div class="item">
                  공지사항
                </div>
              </h3>
            </div>
            <div class="notice-search" v-if="userInfo.userRole !== undefined && userInfo.userRole !== 'ClubManager'">
              <div class="body">
                <div class="form">
                  <div class="select">
                    <div class="formSelect" ref="select01" @click="openSelect01">
                      <div class="formSelectList">
                        <input type="text" :value="(selectType==='') ? '' : (selectType==='전체') ? '전체' : findNoticeStatusName(selectType)" placeholder="유형" readonly />
                      </div>
                      <div class="formSelectPopup select01">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="검색어를 입력하세요." />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="전체" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>전체</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Checking" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>확인중</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Event" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>이벤트</span>
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" v-model="selectedType" value="Version" v-on:change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>버전</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="input">
                    <input type="text" v-model="searchWordValue" placeholder="검색어를 입력하세요" @keyup.enter="search"/>
                  </div>
                  <div class="search" @click="search">
                    <button>
                      검색
                    </button>
                  </div>
                </div>
                <div class="registration" @click="moveMenu('/CS003')">
                  <button>
                    등록하기
                  </button>
                </div>
              </div>
            </div>
            <div class="notice-board">
              <div class="header">
                <ul class="list">
                  <li class="object">
                    대상
                  </li>
                  <li class="type">
                    유형
                  </li>
                  <li class="title">
                    제목
                  </li>
                  <li class="writer">
                    작성자
                  </li>
                  <li class="date">
                    작성일
                  </li>
                </ul>
              </div>
              <!-- 데이터 없을때(Class) : none -->
              <div class="body" :class="((noticeList1 !== null) && (noticeList1.length === 0)) ? 'none': ''">
                <ul class="list">
                  <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
                  <!-- 비활성화(Class) : disabled -->
                  <li v-for="noticeListInfo in noticeList1" :key="noticeListInfo.account_id" @click="moveMenu('/CS002?notice_id='+noticeListInfo.notice_id)" :class="((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Version')) ? 'typeVersion' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Version')) ? 'typeVersion disabled' : ((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Event')) ? 'typeEvent' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Event')) ? 'typeEvent disabled' : ((noticeListInfo.status=='ACTIVE')&&(noticeListInfo.notice_type=='Checking')) ? 'typeChecking' : ((noticeListInfo.status=='PASSIVE')&&(noticeListInfo.notice_type=='Checking')) ? 'typeChecking disabled' : noticeListInfo.notice_type">
                    <div class="object">
                      <div class="item">
                        {{ (noticeListInfo.target_all_yn === 1) ? '전체' : (noticeListInfo.targetInfo === '') ? '미입력' : (noticeListInfo.targetInfo.length > 2) ? noticeListInfo.targetInfo : '골프클럽(' + noticeListInfo.targetInfo + ')'}}
                      </div>
                    </div>
                    <div class="type">
                      <div class="item">
                        {{ (noticeListInfo.notice_type=='Version') ? '버전' : (noticeListInfo.notice_type=='Event') ? '이벤트' : (noticeListInfo.notice_type=='Checking') ? '확인중' : noticeListInfo.notice_type }}
                      </div>
                    </div>
                    <div class="title">
                      <div class="item">
                        {{noticeListInfo.title}}
                      </div>
                    </div>
                    <div class="writer">
                      <div class="item">
                        {{((findAccountId(noticeListInfo.isrt_id) !== undefined) && (findAccountId(noticeListInfo.isrt_id) !== null) && (findAccountId(noticeListInfo.isrt_id) !== '')) ? findAccountId(noticeListInfo.isrt_id) : (userInfo.userName === '') ? '미입력' : userInfo.userName  }}
                      </div>
                    </div>
                    <div class="date">
                      <div class="item">
                        {{(noticeListInfo.isrt_dt!=null) ? noticeListInfo.isrt_dt.substring(0,10) : '미입력'}}
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="none">
                  등록된 게시물이 없습니다.
                </div>
              </div>
            </div>
            <div class="notice-page">
              <!-- 이전 활성 : prevActive / 다음 활성 : nextActive -->
              <div class="paging" :class="pageClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    이전
                  </div>
                </div>
                <ul class="number" v-for="index in pageArray" :key="index">
                  <!-- 활성 : active -->
                  <li :class="index == pageNo? 'active': ''" @click="getPage(index)">
                    {{ index }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    다음
                  </div>
                </div>
              </div>
            </div>
            <div class="notice-more">
              <div class="more" v-if="pageNo < noticeCnt/pageSize" @click="moreMobileData" >
                더보기
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    답변을 등록하면 문의자에게<br />
                    알림이 발송됩니다.<br />
                    이대로 등록하시겠습니까?
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {aplManagerService, clubInfoService, userService} from '../../router'

export default {
  name: 'CS001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  data () {
    return {
      paramStatus: '',
      paramAuthority: '',
      paramselectType: '',
      paramPageNo: 1,
      paramPageSize: 10,
      selectedType: '',
      doneindex: 0,
      fetched: 'false',
      clubInfoList: [],
      clubString: '',
      clubTargets: [],
      accountInfoList: [],
      noticeListUserIds: [],
      noticeListRoles: [],
      noticeListNames: [],
      noticeListIds: [],
      noticeList1: null,
      loading: true,
      orderTarget: '',
      orderValue: '',
      searchWordValue: '',
      selectType: '',
      selectValue: '',
      search_type: '',
      sortColumn: '',
      sortType: '',
      pageNo: 1,
      pageIndex: 0,
      pageSize: 10,
      pageBuffer: 5,
      noticeCnt: 0,
      noticeList: null,
      search_word: '',
      accountUserInfo: [],
      account_id: '',
      user_id: '',
      status: '',
      user_name: '',
      user_role: '',
      user_phone: '',
      user_email: '',
      ccode: '',
      CustomerNoticeInfoList: [],
      statusNoticeTypeList: [
        {
          statusCode: 'Checking',
          statusName: '확인중'
        },
        {
          statusCode: 'Event',
          statusName: '이벤트'
        },
        {
          statusCode: 'Version',
          statusName: '버전'
        }
      ]
    }
  },
  created: function () {
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  mounted: function () {
    document.querySelector('body.type-content').classList.remove('select01Active')
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        document.querySelector('body.type-content').classList.add('loginClub')
        Promise.all([clubInfoService.getClubInfoList('active'), aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue)])
          .then(response => {
            this.clubInfoList = response[0].data.clubInfoList
            this.CustomerNoticeInfoList = response[1].data
            this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
            this.noticeList1 = this.CustomerNoticeInfoList.noticeList
          }).catch(error => {
            console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
          })
      } else {
        Promise.all([aplManagerService.getSummaryManagementUserListView(this.orderTarget, this.orderValue, this.paramStatus, this.paramAuthority, this.search_word), clubInfoService.getClubInfoList('active'), aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue)])
          .then(response => {
            this.accountInfoList = response[0].data.accountList
            this.clubInfoList = response[1].data.clubInfoList
            this.CustomerNoticeInfoList = response[2].data
            this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
            this.noticeList1 = this.CustomerNoticeInfoList.noticeList
          }).catch(error => {
            console.log('getCustomerNoticeTargetsNoticeId.err.===>', error)
          })
      }
    })
  },
  methods: {
    resetSearchParams: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.paramPageNo = 1
      this.paramPageSize = 10
      this.paramStatus = ''
      this.paramAuthority = ''
      this.paramselectType = ''
      this.selectType = ''
      this.selectedType = ''
      this.searchWordValue = ''
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.resetSearchParams()
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.resetSearchParams()
          this.setData()
        }
      }
    },
    findAccountId: function (accountId) {
      if (this.accountInfoList.find(it => it.account_id === accountId) !== undefined) {
        return this.accountInfoList.find(it => it.account_id === accountId).user_name
      } else {
        return ''
      }
    },
    moreMobileData: function () {
      this.pageNo += 1
      this.paramPageNo = this.pageNo
      aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue).then(response => {
        this.noticeCnt = response.data.noticeCnt
        this.noticeList1 = this.noticeList1.concat(response.data.noticeList)
      })
    },
    findNoticeStatusName: function (status) {
      if (this.statusNoticeTypeList.find(it => it.statusCode === status) !== undefined) {
        return this.statusNoticeTypeList.find(it => it.statusCode === status).statusName
      } else {
        return ''
      }
    },
    nextPage: function () {
      if (this.pageIndex >= this.pageIndexMax) return
      this.pageIndex++
      this.move_another_page(this.pageArray[0])
    },
    prevPage: function () {
      if (this.pageIndex <= 0) return
      this.pageIndex--
      this.move_another_page(this.pageArray[this.pageArray.length - 1])
    },
    getPage: function (index) {
      this.pageNo = index
      this.paramPageNo = index
      this.setData()
    },
    move_another_page: function (index) {
      this.pageNo = index
      this.paramPageNo = index
      this.setData()
    },
    search: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.paramPageNo = 1
      this.paramPageSize = 10
      this.setData()
    },
    setData: function () {
      // alert(this.search_word)
      this.selectType = this.selectedType
      this.paramselectType = this.selectType
      if (this.paramselectType === '전체') this.paramselectType = ''
      aplManagerService.getCustomerNoticeListView(this.paramPageNo, this.paramPageSize, this.paramselectType, this.searchWordValue).then(response => {
        this.CustomerNoticeInfoList = response.data
        this.noticeList1 = this.CustomerNoticeInfoList.noticeList
        this.noticeCnt = this.CustomerNoticeInfoList.noticeCnt
      }).catch(error => {
        console.log('getCustomerNoticeListView.err.===>', error)
      })
    }
  },
  computed: {
    pageArray: function () {
      if (this.noticeCnt <= 0) return [1]
      let pageMax = Math.floor((this.noticeCnt - 1) / this.pageSize) + 1
      let arr = []
      for (let i = 1; i <= this.pageBuffer; i++) {
        let j = this.pageIndex * this.pageBuffer + i
        if (j > pageMax) break
        arr.push(j)
      }
      return arr
    },
    pageIndexMax: function () {
      return Math.floor((this.noticeCnt - 1) / (this.pageSize * this.pageBuffer))
    },
    pageClass: function () {
      return {
        nextActive: this.pageIndex < this.pageIndexMax,
        prevActive: this.pageIndex > 0
      }
    }
  },
  watch: {
    pageIndex: function (val) {
      this.pageIndex = val < 0 ? 0 : val > this.pageIndexMax ? this.pageIndexMax : val
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cs/CS001.vue